<template>
    <ul :class="[$style['mds-list-group'], classObject, sizeClass]" :data-mds-version="version">
        <slot></slot>
    </ul>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsListGroup',
        props: {
            onDark: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, changes component to on-dark styling.',
                },
            },
            size: {
                type: String,
                default: 'medium',
                validator(value) {
                    return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `small`, `medium`, `large`, `touch`.',
                    description: 'Sets the size of the list group.',
                },
            },
            variation: {
                type: String,
                default: 'default',
                validator(value) {
                    return ['default', 'selection', 'navigation'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `default`, `selection`, `navigation`.',
                    description: 'Sets the list group variation.',
                },
            },
            withIcon: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, creates space in list group items for an icon.',
                },
            },
            version: {
                type: String,
                default: `${name}-${version}`,
                docs: {
                    validation: 'Read-only',
                    description:
                        'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
                },
            },
        },
        provide() {
            // Properties that are available for injection into components descendants https://vuejs.org/v2/api/#provide-inject
            const parentVariation = {};
            Object.defineProperty(parentVariation, 'variationObj', {
                enumerable: true,
                get: () => this.variation,
            });
            Object.defineProperty(parentVariation, 'size', {
                enumerable: true,
                get: () => this.size,
            });
            return { parentVariation };
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-list-group--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-list-group__navigation']] = this.variation === 'navigation';
                obj[this.$style['mds-list-group--with-icon']] = this.withIcon;
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './list-group.scss';
</style>
